'use client';
import { motion } from 'framer-motion';
import { Ctext } from '@/components/ui/Ctext';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { pxToRem } from '@/theme/spacing';
import type { DataElScope } from '@/utils/dataEl';
import type { ReactElement } from 'react';
import { FakeCommentFileActionContent } from './FakeCommentFileActionContent';
import { FAKE_COMMENT_MESSAGE_KIND } from './cfakecommentConstants';
import type { FakeCommentMessage } from './cfakecommentTypes';
interface FakeCommentMessageContentProps {
    dataElScope: DataElScope;
    message: FakeCommentMessage;
    animationDelay: number;
    isMobile: boolean;
}
export function FakeCommentMessageContent({ dataElScope, message, animationDelay, isMobile, }: FakeCommentMessageContentProps): ReactElement {
    const isTextMessage = message.kind === FAKE_COMMENT_MESSAGE_KIND.Text;
    const messageIdentity = isTextMessage ? message.body : `${message.action}-${message.fileName}`;
    return <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: animationDelay + 0.2, ease: [0.4, 0, 0.2, 1] }}>
            {isTextMessage ? (<div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: pxToRem(12),
            }}>
	                    <Ctext size={17} weight={FontWeight.Medium} color={ColorType.White} opacity={0.8} style={{
                lineHeight: 1.5,
                wordBreak: 'break-word',
            }}>
                        {message.body}
                    </Ctext>
	                    {message.files?.map((file) => (<FakeCommentFileActionContent key={`${file.action}-${file.fileName}-${file.versionLabel ?? 'unversioned'}`} dataElScope={dataElScope} message={file} isMobile={isMobile}/>))}
                </div>) : (<FakeCommentFileActionContent dataElScope={dataElScope} message={message} isMobile={isMobile}/>)}
        </motion.div>
        ;
}
